// loaders.gl, MIT license
import {Log} from '@probe.gl/log';

export const log = new Log({id: 'loaders.gl'});
